// extracted by mini-css-extract-plugin
export default {"container":"Tidbits_container__j3gfp","header":"Tidbits_header__LIJ0N"};